import { DataStore } from "aws-amplify";
import { Team } from "../../../models";
import { TeamDAO } from "./TeamDAO";

export class DataStoreTeamDAO implements TeamDAO {
    public async listByOrganizationId(organizationId: string): Promise<Team[]> {
        return await DataStore.query(Team, team => team.organizationId("eq", organizationId));
    }

    public async getById(id: string): Promise<Team | null> {
        return (await DataStore.query(Team, id)) ?? null;
    }
}

export const dataStoreTeamDAO = new DataStoreTeamDAO();